import { createFileRoute, Outlet } from "@tanstack/react-router";
import Header from "@/components/Header";
import { MarketingPageBackground } from "@/components/misc/marketing-layout";

export function Marketing() {
	return (
		<div className="isolate flex min-h-dvh flex-col bg-background">
			<MarketingPageBackground />
			<Header />
			<main className="marketing-display-font relative flex min-h-0 flex-1 flex-col">
				<Outlet />
			</main>
		</div>
	);
}

/* istanbul ignore start -- TanStack Router file route registration */
export const Route = createFileRoute("/_marketing")({
	component: Marketing,
});
/* istanbul ignore end */
